import type { OperatorMapLegendItem } from '@buxus/shared'
import { OperatorLegendSymbol } from './OperatorLegendSymbol'

type OperatorLegendBarProps = {
  items: readonly OperatorMapLegendItem[]
  className?: string
  /** Accessible name prefix (operator / asset title). */
  ariaLabel?: string
}

/** Mobile `OperatorCard` legend row — symbol + label pairs on black bar. */
export function OperatorLegendBar({ items, className, ariaLabel }: OperatorLegendBarProps) {
  if (!items.length) return null
  return (
    <div
      className={['operator-legend-bar', className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <span
          key={`${item.label}-${item.color}-${item.symbol}`}
          className="operator-legend-bar-item"
        >
          <span className="operator-legend-symbol-slot" aria-hidden>
            <OperatorLegendSymbol symbol={item.symbol} color={item.color} />
          </span>
          <span className="operator-legend-label">{item.label}</span>
        </span>
      ))}
    </div>
  )
}
